import {
    CLEAR_ECGS,
    ECGS_DOC_LOADING,
    GET_ECGS_DATA,
    GET_ECGS_DOCUMENT,
    GET_ECGS_LIST_DATA,
    RESET_ECG_MODAL,
    SET_ECG_LOADING,
} from './ecgList.type'
import axios from 'axios'
import { toggleDeactivateModal, toggleSessionModal } from '../../modals/toggleModal.actions'

export const getEcgsListData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_ECG_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/ecg/list`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_ECGS_LIST_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const getEcgsData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_ECG_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/ecg/view`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_ECGS_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_ECG_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const getEcgsDocument = (payload, token) => async (dispatch) => {
    dispatch({
        type: ECGS_DOC_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/ecg/list-documents`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_ECGS_DOCUMENT,
                    payload: response.data.output,
                })
                dispatch({
                    type: ECGS_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: ECGS_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: ECGS_DOC_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const resetEcgDocument = () => (dispatch) => {
    dispatch({
        type: RESET_ECG_MODAL,
    })
}

export const clearEcgs = () => (dispatch) => {
    dispatch({
        type: CLEAR_ECGS,
    })
}
